<template>
	<label>
		<common-tooltip class="setting-label" :icon="icon" :force-show="forceShow">
			<template #tooltip
				><slot name="tooltip">{{ tooltip }}</slot></template
			>
			<span class="setting-label-text"
				><slot name="label">{{ label }}</slot></span
			>
		</common-tooltip>

		<slot></slot>
	</label>
</template>
<script>
export default {
	props: {
		label: {
			type: String,
			default: '',
		},
		tooltip: {
			type: String,
			default: '',
		},
		forceShow: Boolean,
		icon: {
			type: [String, Boolean],
			default() {
				return 'default-help';
			},
		},
	},
};
</script>
